import { Injectable, Provider } from '@angular/core';
import { BetaFeature } from './ajs-perfil.service';

@Injectable()
export class IntegrationService {
  public getEnabledProviders(features: BetaFeature[]): any[] {
    return [];
  }

  public async connect(provider: any) {
    return provider;
  }

  public async disconnect(provider: any) {
    return provider;
  }

  public async authorize(providerSlug: string, params: any) {
    return { params, providerSlug };
  }

  public async tryAuthorizeAccount(provider: any) {
    return provider;
  }

  public async tryAuthorizeAccountsBatch(providers: any[]) {
    return providers;
  }
}

export function IntegrationServiceFactory(i: any) {
  return i.get('IntegrationService');
}

export const IntegrationServiceProvider: Provider = {
  provide: IntegrationService,
  useFactory: IntegrationServiceFactory,
  deps: [ '$injector' ],
};
